import {
  RECENTER,
  UPDATE_VIEWPORT,
  ACTIVATE_MAP,
  TOGGLE_PIN,
  RECEIVE_NEW_ACTIVITY,
  FAILURE_NEW_ACTIVITY,
  SET_PLACING_PIN,
} from '../constants/actionTypes';

export const initialState = {
  isReady: false,
  currentViewport: {},
  defaultViewport: null,
  isRecenterButtonVisible: true,
  isPlacingPin: false,
};

/**
 * Handles redux state for map view
 * @param {Object} state
 * @param {Object} action
 * @return {Object} new state
 */
function mapReducer(state = initialState, action = {}) {
  switch (action.type) {
    case ACTIVATE_MAP:
      return {
        ...state,
        isReady: true,
        defaultViewport: action.viewport,
      };
    case UPDATE_VIEWPORT:
      return {
        ...state,
        currentViewport: action.viewport,
      };
    case RECENTER:
      return {
        ...state,
        currentViewport: state.defaultViewport,
      };
    case TOGGLE_PIN:
      return {
        ...state,
        isPlacingPin: !state.isPlacingPin,
      };
    case SET_PLACING_PIN:
      return {
        ...state,
        isPlacingPin: action.payload,
      };
    case RECEIVE_NEW_ACTIVITY:
      return {
        ...state,
        isPlacingPin: false,
      };
    case FAILURE_NEW_ACTIVITY:
      return {
        ...state,
        isPlacingPin: false,
      };
    default:
      return state;
  }
}

export default mapReducer;
